<div *ngIf="fengEndedSells == true; else showEvent">
  <div *ngIf="eventSlug == 'pecuaria-de-goiania-16-05-24'; else showSellsEnd">
    <p class="d-flex mt-5 justify-content-center fs-5">
      Troque 1kg de alimento não perecível na bilheteria do Parque de
      Exposições<br />
      <b>No dia do show.</b>
    </p>
  </div>
  <ng-template #showSellsEnd>
    <p *ngIf="eventSlug != 'inauguração-pereira-hall-20-anos-am-eventos' && eventSlug !='forro-do-rancho-2025'"
      class="d-flex mt-5 justify-content-center fs-5">Vendas encerradas.</p>

    <div *ngIf="eventSlug == 'forro-do-rancho-2025'" class="text-center mt-5 fs-5">
      <p>LOTE ESGOTADO!</p>
      <p>REABERTURA DAS VENDAS EM BREVE.</p>
      <p>Abertura 15/04 às 07:00h</p>
    </div>

    <div *ngIf="eventSlug == 'inauguração-pereira-hall-20-anos-am-eventos'" class="text-center mt-5 fs-5">
      <p>LOTE PROMOCIONAL ENCERRADO!</p>
      <p>REABERTURA DAS VENDAS EM BREVE.</p>
    </div>
  </ng-template>
</div>
<ng-template #showEvent>
  <div *ngIf="event">
    <div>
      <div *ngIf="
          fengIntegration == false &&
          event!.banner != null &&
          event!.banner !== '' && showBanner == true
          && categorySports == false
        " class="banner">
        <img [src]="event.banner" *ngIf="event" />
        <ngx-skeleton-loader [theme]="{ height: '100%' }" *ngIf="!event"></ngx-skeleton-loader>
      </div>

      <div *ngIf="event!.id == 'ecd5d096-2c15-4d93-a670-515b525180d0'" class="banner">
        <img src="../../../../assets/images/vasco-arte.png" />
      </div>

      <div class="container-fluid mt-4">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2 class="title fw-bold text-grad text-break" *ngIf="event">
              {{ event.name }}
            </h2>
            <ngx-skeleton-loader [theme]="{ 'max-width': '300px', height: '50px' }"
              *ngIf="!event"></ngx-skeleton-loader>
          </div>
        </div>

        <div *ngIf="event != null && event.id == '53ef9bc2-02a6-4f8b-a9ca-bb452fbe98db' && isCountDown0 != true">
          <app-countdown (sendOpenEvent)="getOpenEvent($event)" eventTimeStartSell="12:00"
            eventDateStartSell="2025-03-17"></app-countdown>
        </div>

        <div *ngIf="showEventInfo == true" class="row flex-column-reverse flex-lg-row">
          <div class="col-sm-12 col-lg-5 col-xl-6">
            <div class="row">
              <div>
                <div class="col-md-12 mt-4">
                  <div class="card border-0">
                    <div class="card-header border-0 pt-3">
                      <h5 class="card-title text-grad text-uppercase fw-bold" *ngIf="event">
                        Sobre o evento
                      </h5>
                      <ngx-skeleton-loader [theme]="{ 'max-width': '150px', margin: '0' }"
                        *ngIf="!event"></ngx-skeleton-loader>
                    </div>
                    <div class="card-body pt-0">
                      <img class="w-100" [src]="event.banner" *ngIf="event && categorySports == true" />
                      <p class="card-text description" *ngIf="event?.description" [innerHtml]="event?.description"></p>
                      <ngx-skeleton-loader [theme]="{ height: '300px', margin: '0' }"
                        *ngIf="!event"></ngx-skeleton-loader>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-4">
                <div class="card border-0">
                  <div class="card-header border-0 pt-3">
                    <h5 class="card-title text-grad text-uppercase fw-bold" *ngIf="event">
                      Localização
                    </h5>
                    <ngx-skeleton-loader [theme]="{ 'max-width': '150px', margin: '0' }"
                      *ngIf="!event"></ngx-skeleton-loader>
                  </div>
                  <div class="card-body pt-0 pb-2">
                    <iframe allowfullscreen frameborder="0" height="300" style="border: 0; border-radius: 5px"
                      width="100%" [src]="event.googleMapsUrl" *ngIf="event">
                    </iframe>
                    <ngx-skeleton-loader [theme]="{ height: '300px', margin: '0' }"
                      *ngIf="!event"></ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-7 col-xl-6">
            <div class="row">
              <div class="col-md-12 mt-4">
                <div class="card border-0">
                  <div class="card-body postiion-relative">
                    <div *ngIf="event!.instagram != null && event!.instagram !=''" class="position-absolute"
                      style="top: -31px; right: 0px">
                      <a [href]="'https://instagram.com/'+event!.instagram" target="blank"><img width="41"
                          src="../../../../assets/images/instagram_redondo.png" /></a>
                    </div>
                    <div class="date text-grad">
                      <ng-container *ngIf="event">
                        <div *ngIf="
                            ![
                              'f0aa98ac-686f-4e28-9bce-617612f99860',
                              '43c00201-57c7-43c1-ade5-0d4d742a33a8',
                              '7067c247-dec4-4f85-89c5-69efc403e37d',
                              '846387aa-74b6-49a5-b00b-c64c51de219b',
                              '54baac91-9fa2-4662-9ef4-7db0a036b560',
                              '5384208e-ac70-4ccb-ab45-c533e9db168b',
                              '661af29a-d682-4921-82f7-f975b61f7c7f',
                              'c298c0de-33e8-45e9-926d-139197151ea8',
                              '62b86f5e-7b43-4e50-88c8-3126feb2e612',
                              '99160a3f-ca76-4d26-8839-5b2faa3f01b8',
                              '12e8e480-c1f3-4e42-b4fc-006c4913ca89',                            
                              'e31c2e19-5c6c-46b5-be0b-26ab22ec7d1a',
                              '5df88dae-f455-4fc3-b52f-acf9db18bdd8',
                              '7e738a78-e096-4c68-85a1-7fbb738649c2',
                              '5e5affea-e677-4bf3-96bc-ddfdf1108239',
                              '034f7ecc-db4f-4043-8ce4-a911ad9c0ac7',
                              'c0511076-af8a-4cfb-9ef2-5d4330fa80d1',
                              'b8ba4158-c405-40fe-bd3f-afb4104aeef3',
                              '1278a368-d497-4001-ab7e-4339beca5f5e',
                              '8f79b037-f5e9-49e8-8726-02a19fd360e3',
                              '6bd659ae-9bbe-4cf4-a9e0-83b30d96c749',
                              '3500a1e5-eebc-454c-881c-c9287952b93b'
                            ].includes(event.id)
                          ">

                          <p class="text-capitalize fw-bold m-0"
                            *ngIf="event['dateEnd'] == null else showDateStartDateEnd">
                            {{ event.startDate }}
                          </p>
                          <ng-template #showDateStartDateEnd>
                            <p class="text-capitalize fw-bold m-0"
                              *ngIf="event['dateEnd'] != null else showDateStartDateEnd">
                              de {{ event["dates"][0] | date:'dd/MM' }} <b style="text-transform: lowercase;">a</b>
                              {{event["dateEnd"] | date:'dd/MM'}}
                            </p>
                          </ng-template>
                        </div>
                        <div *ngIf="
                            event.id == 'f0aa98ac-686f-4e28-9bce-617612f99860'
                          ">
                          <p class="fw-bold m-0">04 e 05 de março</p>
                        </div>
                        <div *ngIf="
                            event.id == '43c00201-57c7-43c1-ade5-0d4d742a33a8'
                          ">
                          <p class="fw-bold m-0">04 e 05 de março</p>
                        </div>
                        <div *ngIf="
                            event.id == '7067c247-dec4-4f85-89c5-69efc403e37d'
                          ">
                          <p class="fw-bold m-0">Dia 18 a dia 28 de maio</p>
                        </div>
                        <div *ngIf="
                            event.id == '12e8e480-c1f3-4e42-b4fc-006c4913ca89'
                          ">
                          <p class="fw-bold m-0">07 a 23 de Fevereiro</p>
                        </div>
                        <div *ngIf="
                          event.id == 'e31c2e19-5c6c-46b5-be0b-26ab22ec7d1a'
                        ">
                          <p class="fw-bold m-0">27 de Fevereiro até 04 de Março</p>
                        </div>
                        <div *ngIf="
                            event.id == '846387aa-74b6-49a5-b00b-c64c51de219b'
                          ">
                          <p class="fw-bold m-0">DIAS 09 e 10/06</p>
                        </div>
                        <div *ngIf="
                            event.id == '54baac91-9fa2-4662-9ef4-7db0a036b560'
                          ">
                          <p class="fw-bold m-0">30 e 31 de dezembro</p>
                        </div>
                        <div *ngIf="
                            event.id == '5384208e-ac70-4ccb-ab45-c533e9db168b'
                          ">
                          <p class="fw-bold m-0">04/10 a 04/11</p>
                        </div>
                        <div *ngIf="
                            event.id == '661af29a-d682-4921-82f7-f975b61f7c7f'
                          ">
                          <p class="fw-bold m-0">12 a 15 de outubro</p>
                        </div>
                        <div *ngIf="
                            event.id == '5384208e-ac70-4ccb-ab45-c533e9db168b'
                          ">
                          <p class="fw-bold m-0">04/10 a 02/11</p>
                        </div>
                        <div *ngIf="
                            event.id == '661af29a-d682-4921-82f7-f975b61f7c7f'
                          ">
                          <p class="fw-bold m-0">04/10 a 02/11</p>
                        </div>
                        <div *ngIf="
                          event.id == 'c298c0de-33e8-45e9-926d-139197151ea8'
                        ">
                          <p class="fw-bold m-0">07 e 08 de Setembro</p>
                        </div>
                        <div *ngIf="
                          event.id == '62b86f5e-7b43-4e50-88c8-3126feb2e612'
                        ">
                          <p class="fw-bold m-0">23 e 24 de Maio</p>
                        </div>

                        <div *ngIf="
                          event.id == '99160a3f-ca76-4d26-8839-5b2faa3f01b8'
                        ">
                          <p class="fw-bold m-0">14 e 15 de Fevereiro</p>
                        </div>
                        <div *ngIf="
                          event.id == '5df88dae-f455-4fc3-b52f-acf9db18bdd8'
                        ">
                          <p class="fw-bold m-0">28/02 até 03/03</p>
                        </div>
                        <div *ngIf="
                          event.id == '7e738a78-e096-4c68-85a1-7fbb738649c2'
                        ">
                          <p class="fw-bold m-0">01 a 03 de Março</p>
                        </div>
                        <div *ngIf="
                          event.id == '5e5affea-e677-4bf3-96bc-ddfdf1108239'
                        ">
                          <p class="fw-bold m-0">DIA 18/04 ao DIA 19/04</p>
                        </div>
                        <div *ngIf="
                          event.id == '034f7ecc-db4f-4043-8ce4-a911ad9c0ac7'
                        ">
                          <p class="fw-bold m-0">27/02 a 04/03</p>
                        </div>
                        <div *ngIf="
                        event.id == 'c0511076-af8a-4cfb-9ef2-5d4330fa80d1'
                      ">
                          <p class="fw-bold m-0">04 e 05 de Abril</p>
                        </div>
                        <div *ngIf="
                        event.id == 'b8ba4158-c405-40fe-bd3f-afb4104aeef3'
                      ">
                          <p class="fw-bold m-0">02 e 03 de Maio</p>
                        </div>
                        <div *ngIf="
                        event.id == '1278a368-d497-4001-ab7e-4339beca5f5e'
                      ">
                          <p class="fw-bold m-0">De 30/04 a 03/05 de 2025</p>
                        </div>
                        <div *ngIf="
                        event.id == '8f79b037-f5e9-49e8-8726-02a19fd360e3'
                      ">
                          <p class="fw-bold m-0">23 de Junho, Véspera de Feriado</p>
                        </div>
                        <div *ngIf="
                        event.id == '6bd659ae-9bbe-4cf4-a9e0-83b30d96c749'
                      ">
                          <p class="fw-bold m-0">30/04 a 03/05</p>
                        </div>
                        <div *ngIf="
                        event.id == '3500a1e5-eebc-454c-881c-c9287952b93b'
                      ">
                          <p class="fw-bold m-0">De 18/06 a 23/06</p>
                        </div>
                        <p class="fw-bold m-0">{{ event.startTime }}</p>
                      </ng-container>
                      <ng-container *ngIf="!event">
                        <ngx-skeleton-loader [theme]="{
                            'max-width': '200px',
                            height: '40px',
                            margin: '0'
                          }"></ngx-skeleton-loader>
                        <br />
                        <ngx-skeleton-loader [theme]="{
                            'max-width': '100px',
                            height: '30px',
                            margin: '0'
                          }"></ngx-skeleton-loader>
                      </ng-container>
                    </div>
                    <div class="local mt-3">
                      <ng-container *ngIf="event">
                        <h6 class="fw-bold m-0">{{ event.address }}</h6>
                        <div *ngIf="event.id != '170d124f-20ac-41e3-b817-a4bc20dc5ed9' &&
                        event.id != '8a9997c1-d82b-4db3-9fc7-aecb4dfeed2b' && 
                        event.id != 'd085263e-0417-4d32-8832-b55fa9a6167a' &&
                        event.id != 'b6122d1a-30a5-4c7a-8d2b-f75efed20d49' else showCustomPlace">
                          <p class="m-0">{{ event.city }} - {{ event.uf }}</p>
                        </div>
                        <ng-template #showCustomPlace>
                          <p *ngIf="event.id == '170d124f-20ac-41e3-b817-a4bc20dc5ed9'" class="m-0">Lisboa</p>
                          <p *ngIf="event.id == '8a9997c1-d82b-4db3-9fc7-aecb4dfeed2b'" class="m-0">Porto</p>
                          <p *ngIf="event.id == 'd085263e-0417-4d32-8832-b55fa9a6167a'" class="m-0">Bostom</p>
                          <p *ngIf="event.id == 'b6122d1a-30a5-4c7a-8d2b-f75efed20d49'" class="m-0">Miami</p>
                        </ng-template>
                      </ng-container>
                      <ng-container *ngIf="!event">
                        <ngx-skeleton-loader [theme]="{ 'max-width': '200px', margin: '0' }"></ngx-skeleton-loader>
                        <br />
                        <ngx-skeleton-loader [theme]="{ 'max-width': '150px', margin: '0' }"></ngx-skeleton-loader>
                      </ng-container>
                    </div>

                    <!-- Remover após 25-04-2025 -->
                    <div *ngIf="event?.id == '62b86f5e-7b43-4e50-88c8-3126feb2e612'">
                      <div class="bb-seguros-discount mb-2 mt-4">
                        <div class="d-flex align-items-center flex-wrap rounded-3 p-3" style="background-color: #fedb00;">
                          <img src="https://www.sindsegsp.org.br/site//content/images/noticias/637499373635617857.png"
                            alt="BB Seguros" class="me-3" style="height: 32px;">
                          <div class="flex-grow-1">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Informe seu CPF para desconto"
                                mask="000.000.000-00" [formControl]="bbSegurosControl">
                              <button class="btn" style="background-color: #0033ab; color: #fff;" type="button"
                                (click)="aplicarDescontoBBSeguros()">
                                APLICAR
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="showCupom">
                      <p class="fs-4 text-center mt-3 mb-3" *ngIf="ticketCupom != '' && cupomSent == true && (showSales == false || cupomSales == null)"><b>Cupom aplicado:</b> {{ticketCupom}}</p>
                      <p class="fs-5 text-center mt-3 mb-3" *ngIf="ticketCupom != '' && cupomSent == true && showSales == true && cupomSales != null"><b>Cupom aplicado:</b> {{ticketCupom}} | Vendas: {{cupomSales["totalPedidos"]}} - {{cupomSales["valor"] | currency:'BRL': true}}</p>
                      <div *ngIf="fengIntegration == false; else showFengBadges">
                        <!-- Cupom -->
                        <div *ngIf="
                            (event != null &&
                              event.id ==
                                'e6a772ac-5a35-4724-988d-ad2a648b7ec1') ||
                              event?.id == '408b38ea-c13b-4339-a39e-0d9016e36912';
                            else showNormalCupom
                          ">
                          <div class="mt-4 background-c6">
                            <div class="d-flex align-items-center justify-content-center mb-5 mt-4">
                              <div class="ms-auto me-0" style="margin-top: 156px">
                                <div class="input-group input-group-lg codigo">
                                  <input type="text" maxlength="6" class="form-control"
                                    placeholder="BIN (6 primeiros nrs cartão)" name="ticketCupom"
                                    [(ngModel)]="ticketCupom" required />
                                  <button class="btn btn-grad fw-bold text-uppercase fs-6" [disabled]="loading == true"
                                    (click)="sendCupomTicket()">
                                    Validar
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex justify-content-center" *ngIf="ticketCupomError !== ''">
                              <p style="color: red">{{ ticketCupomError }}</p>
                            </div>
                          </div>
                        </div>
                        <ng-template #showNormalCupom>
                          <div *ngIf="event.showCupom == true"
                            class="d-flex align-items-center justify-content-center mb-5 mt-4">
                            <div class="col-xs-12 col-sm-6 col-md-8 col-xl-8 col-xxl-6 ms-auto me-0">
                              <div class="input-group input-group-lg codigo">
                                <input type="text" class="form-control" placeholder="Código do cupom" name="ticketCupom"
                                  [(ngModel)]="ticketCupom" required />
                                <button class="btn btn-grad fw-bold text-uppercase fs-6" [disabled]="loading == true"
                                  (click)="sendCupomTicket()">
                                  Validar
                                </button>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <div class="d-flex justify-content-center" *ngIf="ticketCupomError !== ''">
                          <p style="color: red">{{ ticketCupomError }}</p>
                        </div>

                        <div class="d-flex justify-content-center" *ngIf="ticketCupomError !== ''">
                          <p style="color: red">{{ ticketCupomError }}</p>
                        </div>
                      </div>
                    </div>
                    <ng-template #showFengBadges>
                      <div *ngIf="
                          eventClosed == false;
                          else showEventClosedMessage
                        ">
                        <div class="row text-center mb-5 mt-5">
                          <div class="col-md-12 feng-integration" *ngIf="fengIntegration">
                            <h3 class="blueTitle">Pode comprar:</h3>
                            <span class="btn btn-grad">Sócio
                              <span class="badge badge-secondary fs-6">{{
                                quantityPctValuePartner
                                }}</span></span>&nbsp;
                            <span class="btn btn-grad">Convidado
                              <span class="badge badge-secondary fs-6">{{
                                quantityPctValueInvited
                                }}</span></span>&nbsp;
                            <span class="btn btn-grad">Extra
                              <span class="badge badge-secondary fs-6">{{
                                quantityPctValueExtra
                                }}</span></span>
                          </div>
                        </div>
                      </div>
                      <ng-template #showEventClosedMessage>
                        <p class="d-flex mt-5 justify-content-center fs-5">
                          Não há ingressos disponíveis para você.
                        </p>
                      </ng-template>
                    </ng-template>

                    <div class="row" *ngIf="event && event.allowMapV2">
                      <div class="col-sm-12">
                        <mapv2 [eventId]="event.id" [sectorId]="selectedSector" (change)="mapV2Change($event)"></mapv2>
                      </div>
                    </div>

                    <div *ngIf="loading == false; else showLoading">
                      <div *ngIf="
                          event.id != '0680522e-20a3-446f-827c-567d99552196' &&
                          event.id != 'e6a8866d-d0d5-4a5a-b478-b537aeed3941'
                        ">
                        <!-- Botões de setores -->
                        <div class="sectors mt-5" id="sectorcontainer">
                          <!-- <swiper
                          style="height: auto; flex-wrap: wrap !important;"
                            class="d-flex justify-content-between" 
                            [config]="sectorsSwiperConfig"
                            (swiper)="sectorsSwiper = $event"
                            
                          > -->
                          <div>
                            <div class="row" *ngIf="hasSeatsChart == true">
                              <section>
                                <ng-container *ngIf="seatsIOSectors.length >= 1">
                                  <div
                                    class="card-body d-flex active col-12 p-3 justify-content-center align-items-center p-2">
                                    <h6 class="text-uppercase d-flex m-auto text-center m-0" style="font-size: 13px">
                                      <ng-container
                                        *ngIf="event.id != 'c7cfd52d-ce94-453e-b28c-f6f710666778' else showFixedNames">
                                        <p class="d-flex w-auto"
                                          *ngFor="let sectorName of seatsIOSectors; let id = index">
                                          {{sectorName}} <b class="ms-1 me-1" *ngIf="id  < seatsIOSectors.length -1"> /
                                          </b>
                                        </p>
                                      </ng-container>
                                      <ng-template #showFixedNames>
                                        <p class="d-flex w-auto">
                                          INFERIOR / SUPERIOR
                                        </p>
                                      </ng-template>
                                    </h6>
                                  </div>
                                  <p class="mt-3 mb-3"><b>CLIQUE NO MAPA ABAIXO E CONFIRA OS INGRESSOS DE CADA SETOR</b>
                                  </p>

                                </ng-container>
                                <app-seatsio [event]="event" (selectedSeats)="
                                    getSelectedSeats($event)
                                  " (sendLoadingSeatsIo)="
                                    getLoadingSeatsIo($event)
                                  " (deselectedSeats)="
                                    removeSelectedSeats($event)
                                  "></app-seatsio>
                              </section>
                            </div>
                            <div *ngFor="
                                let sector of sectors
                                  | sortBy : 'position' : 'asc';
                                let id = index
                              " style="flex-wrap: wrap !important" class="mb-3 d-flex justify-content-between">
                              <div class="card border-0 col-12" [class.active]="selectedSector == sector.id"
                                style="flex-wrap: wrap !important">
                                <!-- (click)="selectSector(sector.id)" -->
                                <div *ngIf="sector.useSeats == false || sector.useSeats == null"
                                  [id]="'sector'+sector.id"
                                  class="card-body d-flex active col-12 p-3 justify-content-center align-items-center p-2">
                                  <h6 class="text-uppercase text-center m-0" style="font-size: 13px">
                                    {{ sector.name }}
                                  </h6>
                                </div>
                              </div>
                              <div class="col-12" *ngIf="sector.showNoTickets == 0 || sector.showNoTickets == null else showNoTickets">
                                <!-- Exibe as opções de ingresso de acordo com o setor selecionado -->
                                <div class="mt-3">
                                  <div *ngIf="
                                      (event &&
                                        sectors![id]!.useSeats != null &&
                                        sectors![id]!.useMapPlace !=
                                          null &&
                                        hasSeatsChart == true &&
                                        sectors![id]!.useSeats ==
                                          true) ||
                                        sectors![id]!.useMapPlace ==
                                          true;
                                      else showTicketsByQuantity
                                    ">

                                    <div *ngIf="
                                        event &&
                                        sector.useMapPlace ==
                                          true
                                      ">
                                      <section class="d-flex w-100 justify-content-center mx-auto">
                                        <div
                                          *ngIf="sector.id !='c764ba14-53bb-4864-bbf2-4fbc6f3baf66' && sector.id !='006647d6-2332-408d-945d-a963811420e9'">
                                          <button *ngIf="event?.id != 'db97f2c2-8d71-45dd-8f72-0efcfedc0f42'"
                                            class="btn btn-light" (click)="openCloseMap(sector.id, map)"><i
                                              class="las la-map-marker text-grad me-2"></i> Abrir mapa de
                                            lugares</button>
                                        </div>
                                        <b>
                                          <p *ngIf="event?.id == 'db97f2c2-8d71-45dd-8f72-0efcfedc0f42'">MESAS ESGOTADAS
                                          </p>
                                        </b>
                                      </section>                                     
                                      <ng-template #map>
                                        <div class="modal-header">
                                          <h4 class="modal-title pull-left">Escolha o seu lugar</h4>
                                          <button type="button" class="btn-close close pull-right" aria-label="Close"
                                            (click)="mapModalRef?.hide(); selectedSeatSector = ''; showMap = false">
                                            <span aria-hidden="true" class="visually-hidden">&times;</span>
                                          </button>
                                        </div>
                                        <div class="modal-body">
                                          <app-map-place *ngIf="showMap == true && selectedSector == sector.id"
                                            [event]="event" [ticketDescription]="mapTicketDescription(sector.id)"
                                            [ticketCupom]="ticketCupom" [sectorId]="selectedSector" (sendSelectedSeat)="
                                            getSelectedMapPlace($event)
                                          "></app-map-place>

                                          <div class="mt-2 d-flex justify-content-center mb-2"
                                            *ngIf="selectedSeatSector == sector.id && amountSelectedSeatSector >= 1">
                                            <button class="btn btn-sm btn-grad" (click)="closeMapModal()">Fechar e
                                              continuar >></button>
                                          </div>

                                        </div>
                                      </ng-template>
                                    </div>
                                  </div>


                                  <!-- Tickets por quantidade (sem ser mapa) -->
                                  <ng-template #showTicketsByQuantity>
                                    <!-- Se tem cupom, lista os cupons, senão vai listar meia, inteira e gratuidade -->
                                    <div *ngIf="
                                        isCupom == true;
                                        else showHalfFullAndGratuityTickets
                                      ">

                                      <ng-container *ngFor="
                                        let ticket of tickets
                                          | filter
                                            : 'sectorId'
                                            : sector.id
                                          | sortBy : 'position' : 'asc'
                                      ">
                                        <div class="animate__animated animate__fadeIn d-flex justify-content-between">
                                          <div class="col-lg-6">
                                            <p class="m-0 fw-bold">
                                              {{ ticket.name }}
                                            </p>
                                            <div class="d-flex">
                                              <p>{{ getTypeBadge(ticket) }}</p>
                                              <p>&nbsp;{{ getTicketGenderBagde(ticket.gender) }}</p>
                                              <p *ngIf="ticket.type == 'Half'">
                                                <i (click)="
                                                    openHalfEntryModalInformation(
                                                      halfEntryModalInformation
                                                    )
                                                  " class="fa fa-info-circle ms-2" style="
                                                    cursor: pointer;
                                                    color: rgb(94, 132, 255);
                                                  "></i>
                                              </p>
                                            </div>
                                            <p class="m-0 text-grad" *ngIf="ticket.batch">
                                              {{ ticket.batch }}
                                            </p>
                                            <div [innerHTML]="ticket.description"></div>
                                            <p class="m-0" *ngIf="ticket.parentRating">
                                              Classificação indicativa: +{{
                                              ticket.parentRating
                                              }}
                                            </p>
                                          </div>
                                          <div class="col-lg-6">
                                            <p class="mb-3 mt-2 mb-3 mt-2 d-flex justify-content-end">
                                              <app-qty [value]="countTickets(ticket.id)" [target]="ticket" [allowAdd]="
                                                  !(
                                                    ticketIdForOnlyOneCustomer
                                                    | isOnlyOneTicketByCustomer
                                                      : ticket.id
                                                  ) && !event?.allowMapV2
                                                " [allowRemove]="!event?.allowMapV2"
                                                (change)="changeQty($event)"></app-qty>
                                            </p>
                                            <p class="total m-0 me-auto fs-4 fw-bold d-flex justify-content-end">
                                              R$
                                              {{
                                              amount(ticket) | number : "1.2-2"
                                              }}
                                            </p>
                                            <p class="price m-0 d-flex justify-content-end">
                                              R$
                                              {{
                                              ticket.price | number : "1.2-2"
                                              }}
                                              (Valor)
                                            </p>
                                            <p class="fee m-0 d-flex justify-content-end">
                                              R$
                                              {{
                                              ticket.fee | number : "1.2-2"
                                              }}
                                              (Taxa)
                                            </p>
                                          </div>
                                        </div>
                                      </ng-container>
                                    </div>
                                    <!-- Lista ingressos por meia, inteira e gratuidade -->
                                    <ng-template #showHalfFullAndGratuityTickets>
                                      <!-- Se a opção de esconder inteiras não estiver marcada, lista os ingressos sem botão de exibir e ocultar inteiras -->
                                      <div *ngIf="
                                          hideFullTicket == false;
                                          else showTicketsByType
                                        ">
                                        <ng-container *ngFor="
                                            let ticket of tickets
                                              | filter
                                                : 'sectorId'
                                                : sector.id
                                              | sortBy : 'position' : 'asc'
                                          ">
                                          <div class="animate__animated animate__fadeIn d-flex justify-content-between">
                                            <div class="col-lg-6">
                                              <p class="m-0 fw-bold">
                                                {{ ticket.name }}
                                              </p>
                                              <div class="d-flex">
                                                <p>{{ getTypeBadge(ticket) }}</p>
                                                <p>&nbsp;{{ getTicketGenderBagde(ticket.gender) }}</p>
                                                <p *ngIf="ticket.type == 'Half'">
                                                  <i (click)="
                                                      openHalfEntryModalInformation(
                                                        halfEntryModalInformation
                                                      )
                                                    " class="fa fa-info-circle ms-2" style="
                                                      cursor: pointer;
                                                      color: rgb(94, 132, 255);
                                                    "></i>
                                                </p>
                                              </div>
                                              <p class="m-0 text-grad" *ngIf="ticket.batch">
                                                {{ ticket.batch }}
                                              </p>
                                              <div [innerHTML]="ticket.description"></div>
                                              <p class="m-0" *ngIf="ticket.parentRating">
                                                Classificação indicativa: +{{
                                                ticket.parentRating
                                                }}
                                              </p>
                                            </div>
                                            <div class="col-lg-6">
                                              <p class="mb-3 mt-2 mb-3 mt-2 d-flex justify-content-end">
                                                <app-qty [value]="
                                                    countTickets(ticket.id)
                                                  " [target]="ticket" [allowAdd]="
                                                    !(
                                                      ticketIdForOnlyOneCustomer
                                                      | isOnlyOneTicketByCustomer
                                                        : ticket.id
                                                    ) && !event?.allowMapV2
                                                  " [allowRemove]="
                                                    !event?.allowMapV2
                                                  " (change)="changeQty($event)"></app-qty>
                                              </p>
                                              <p class="total m-0 me-auto fs-4 fw-bold d-flex justify-content-end">
                                                R$
                                                {{
                                                amount(ticket)
                                                | number : "1.2-2"
                                                }}
                                              </p>
                                              <p class="price m-0 d-flex justify-content-end">
                                                R$
                                                {{
                                                ticket.price | number : "1.2-2"
                                                }}
                                                (Valor)
                                              </p>
                                              <p class="fee m-0 d-flex justify-content-end">
                                                R$
                                                {{
                                                ticket.fee | number : "1.2-2"
                                                }}
                                                (Taxa)
                                              </p>
                                            </div>
                                          </div>
                                        </ng-container>
                                      </div>
                                      <!-- Se a opção de esconder inteira estiver marcada, lista os ingressos com o botão de exibir e ocultar inteiras -->
                                      <ng-template #showTicketsByType>
                                        <ng-container *ngFor="
                                            let ticket of halfTickets ?? tickets
                                              | filter
                                                : 'sectorId'
                                                : sector.id
                                              | sortBy : 'position' : 'asc'
                                          ">
                                          <div class="animate__animated animate__fadeIn d-flex justify-content-between">
                                            <div class="col-lg-6">
                                              <p class="m-0 fw-bold">
                                                {{ ticket.name }}
                                              </p>
                                              <div class="d-flex">
                                                <p>{{ getTypeBadge(ticket) }}</p>
                                                <p>&nbsp;{{ getTicketGenderBagde(ticket.gender) }}</p>
                                                <p *ngIf="ticket.type == 'Half'">
                                                  <i (click)="
                                                      openHalfEntryModalInformation(
                                                        halfEntryModalInformation
                                                      )
                                                    " class="fa fa-info-circle ms-2" style="
                                                      cursor: pointer;
                                                      color: rgb(94, 132, 255);
                                                    "></i>
                                                </p>
                                              </div>
                                              <p class="m-0 text-grad" *ngIf="ticket.batch">
                                                {{ ticket.batch }}
                                              </p>
                                              <div [innerHTML]="ticket.description"></div>
                                              <p class="m-0" *ngIf="ticket.parentRating">
                                                Classificação indicativa: +{{
                                                ticket.parentRating
                                                }}
                                              </p>
                                            </div>
                                            <div class="col-lg-6" *ngIf="ticket.id != 'f42f9060-e0a8-4bfc-ab9d-afc1fdd2d862' else showBetaki">
                                              <p class="mb-3 mt-2 mb-3 mt-2 d-flex justify-content-end">
                                                <app-qty [value]="
                                                    countTickets(ticket.id)
                                                  " [target]="ticket" [allowAdd]="
                                                    !(
                                                      ticketIdForOnlyOneCustomer
                                                      | isOnlyOneTicketByCustomer
                                                        : ticket.id
                                                    ) && !event?.allowMapV2
                                                  " [allowRemove]="
                                                    !event?.allowMapV2
                                                  " (change)="changeQty($event)"></app-qty>
                                              </p>
                                              <p class="total m-0 me-auto fs-4 fw-bold d-flex justify-content-end">
                                                R$
                                                {{
                                                amount(ticket)
                                                | number : "1.2-2"
                                                }}
                                              </p>
                                              <p class="price m-0 d-flex justify-content-end">
                                                R$
                                                {{
                                                ticket.price | number : "1.2-2"
                                                }}
                                                (Valor)
                                              </p>
                                              <p class="fee m-0 d-flex justify-content-end">
                                                R$
                                                {{
                                                ticket.fee | number : "1.2-2"
                                                }}
                                                (Taxa)
                                              </p>
                                            </div>
                                            <ng-template #showBetaki>
                                              <div class="d-flex flex-wrap justify-content-end">
                                                <div class="col-6 mt-3">
                                                  <a  href="https://go.aff.betaki.bet.br/xdszf9vr" target="_blank">
                                                    <img width="101" height="33" src="./assets/images/betaki.png" />
                                                  </a> 
                                                </div>
                                                <div class="col-7">
                                                  <p class="ms-3 mt-2" style ="font-size: 17px">Preço: R$ 20,00</p>
                                                </div>
                                              </div>
                                                
                                            </ng-template>
                                          </div>
                                        </ng-container>
                                        <ng-container *ngFor="
                                            let ticket of fullTickets
                                              | filter
                                                : 'sectorId'
                                                : sector.id
                                              | sortBy : 'position' : 'asc'
                                          ">
                                          <div class="animate__animated animate__fadeIn d-flex justify-content-between">
                                            <ng-container *ngIf="showFullTickets == true">
                                              <div class="col-lg-6">
                                                <p class="m-0 fw-bold">
                                                  {{ ticket.name }}
                                                </p>
                                                <p class="m-0 text-grad" *ngIf="ticket.batch">
                                                  {{ ticket.batch }}
                                                </p>
                                                <p class="m-0" *ngIf="ticket.parentRating">
                                                  Classificação indicativa: +{{
                                                  ticket.parentRating
                                                  }}
                                                </p>
                                              </div>
                                              <div class="col-lg-6">
                                                <p class="mb-3 mt-2 mb-3 mt-2 d-flex justify-content-end" *ngIf="ticket.id !='469b1c59-60af-444d-8d5b-534db3b96d1f'">
                                                  <app-qty [value]="
                                                      countTickets(ticket.id)
                                                    " [target]="ticket" [allowAdd]="
                                                      !(
                                                        ticketIdForOnlyOneCustomer
                                                        | isOnlyOneTicketByCustomer
                                                          : ticket.id
                                                      ) && !event?.allowMapV2
                                                    " [allowRemove]="
                                                      !event?.allowMapV2
                                                    " (change)="changeQty($event)"  
                                                    ></app-qty>
                                                </p>
                                                <p class="total m-0 me-auto fs-4 fw-bold d-flex justify-content-end">
                                                  R$
                                                  {{
                                                  amount(ticket)
                                                  | number : "1.2-2"
                                                  }}
                                                </p>
                                                <p class="price m-0 d-flex justify-content-end">
                                                  R$
                                                  {{
                                                  ticket.price
                                                  | number : "1.2-2"
                                                  }}
                                                  (Valor)
                                                </p>
                                                <p class="fee m-0 d-flex justify-content-end">
                                                  R$
                                                  {{
                                                  ticket.fee | number : "1.2-2"
                                                  }}
                                                  (Taxa)
                                                </p>
                                              </div>
                                            </ng-container>
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="fullTickets.length > 0">
                                          <div class="d-flex justify-content-center">
                                            <button class="btn btn-light animate__animated animate__fadeIn"
                                              (click)="showFullTickets = true" *ngIf="!showFullTickets">
                                              Mostrar Inteiras
                                            </button>
                                            <button class="btn btn-light animate__animated animate__fadeIn"
                                              (click)="showFullTickets = false" *ngIf="showFullTickets">
                                              Ocultar Inteiras
                                            </button>
                                          </div>
                                        </ng-container>
                                      </ng-template>
                                    </ng-template>
                                  </ng-template>
                                  <ng-container *ngIf="!event">
                                    <tr class="animate__animated animate__fadeIn" *ngFor="let sk of [].constructor(3)">
                                      <td class="align-middle">
                                        <ngx-skeleton-loader [theme]="{
                                            width: '200px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                        <br />
                                        <ngx-skeleton-loader [theme]="{
                                            width: '100px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                        <br />
                                        <ngx-skeleton-loader [theme]="{
                                            width: '150px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                      </td>
                                      <td class="text-end align-middle">
                                        <ngx-skeleton-loader [theme]="{
                                            width: '100px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                        <br />
                                        <ngx-skeleton-loader [theme]="{
                                            width: '100px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                        <br />
                                        <ngx-skeleton-loader [theme]="{
                                            width: '100px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                        <br />
                                        <ngx-skeleton-loader [theme]="{
                                            width: '100px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </div>
                                <!-- fim ingressos -->
                              </div>
                              <ng-template #showNoTickets>
                                <p *ngIf="sector.showNoTickets == 1" class="text-center mt-3 mb-3  m-auto">Ingressos esgotados</p>
                                <p *ngIf="sector.showNoTickets == 2" class="text-center mt-3 mb-3  m-auto">Vendas em breve</p>
                              </ng-template>
                            </div>
                            <div *ngIf="event.id == '99a56121-2d0f-404d-be11-81fd583e38e9'">
                              <div style="flex-wrap: wrap !important" class="mb-3 d-flex justify-content-between">

                                <div
                                  class="card-body d-flex active col-12 p-3 justify-content-center align-items-center p-2">
                                  <h6 class="text-uppercase text-center m-0" style="font-size: 13px">
                                    NIVEL 2 CAMAROTE B
                                  </h6>
                                </div>
                                <p class="fw-bold text-danger m-auto text-center mt-4 mb-4">ESGOTADOS</p>
                              </div>
                            </div>
                            <!-- antiga posição do mapa -->
                          </div>
                          <ng-template #showSeatsIo>
                            <section>
                              <app-seatsio [event]="event" (selectedSeats)="
                                  getSelectedSeats($event)
                                " (sendLoadingSeatsIo)="
                                  getLoadingSeatsIo($event)
                                " (deselectedSeats)="
                                  removeSelectedSeats($event)
                                "></app-seatsio>
                            </section>
                          </ng-template>

                          <ng-container *ngIf="!event">
                            <ng-template swiperSlide *ngFor="let sk of [].constructor(5)">
                              <ngx-skeleton-loader [theme]="{
                                  width: '100%',
                                  height: '55px',
                                  margin: '0'
                                }"></ngx-skeleton-loader>
                            </ng-template>
                          </ng-container>
                          <!-- </swiper> -->
                        </div>

                        <!-- </ng-template> -->
                      </div>

                      <div *ngIf="
                          event.id == '0680522e-20a3-446f-827c-567d99552196' ||
                          event.id == 'e6a8866d-d0d5-4a5a-b478-b537aeed3941'
                        ">
                        <!-- Button trigger modal -->
                        <button (click)="
                            selectSector(sectors![0]!.id);
                            canShowMapPlace = true
                          " type="button" class="btn btn-primary" data-bs-toggle="modal"
                          data-bs-target="#exampleModal">
                          <img *ngIf="
                              event.id == '0680522e-20a3-446f-827c-567d99552196'
                            " style="width: 100%" src="./assets/images/mapa de assentos.png" />
                          <img *ngIf="
                              event.id == 'e6a8866d-d0d5-4a5a-b478-b537aeed3941'
                            " style="width: 100%" src="./assets/images/mapa de assentos2.png" />
                        </button>

                        <!-- Modal -->
                        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                          aria-hidden="true">
                          <div class="modal-dialog modal-fullscreen" style="min-width: 100%">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h1 class="modal-title fs-5" id="exampleModalLabel">
                                  Escolha o seu lugar (clique, segure e arraste
                                  para movimentar o mapa)
                                </h1>
                                <button type="button" class="btn-close" (click)="canShowMapPlace = false"
                                  data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div class="modal-body">
                                <div class="sectors mt-3">
                                  <swiper class="d-flex justify-content-between" [config]="sectorsSwiperConfig"
                                    (swiper)="sectorsSwiper = $event">
                                    <ng-template swiperSlide *ngFor="
                                        let sector of sectors
                                          | sortBy : 'position' : 'asc';
                                        let id = index
                                      " class="mb-3 d-flex justify-content-between overflow-y-auto"
                                      style="flex-wrap: wrap">
                                      <div *ngIf="sector.useSeats == false || sector.useSeats == null"
                                        class="card border-0" role="button" [class.active]="
                                          selectedSector == sector.id
                                        " (click)="selectSector(sector.id)">
                                        <div class="card-body d-flex justify-content-center align-items-center p-2">
                                          <h6 class="text-uppercase text-center m-0" style="font-size: 13px">
                                            {{ sector.name }}
                                          </h6>
                                        </div>
                                        <app-map-place *ngIf="canShowMapPlace == true" [event]="event"
                                          [ticketCupom]="ticketCupom" [sectorId]="sectors![id]!.id" (sendSelectedSeat)="
                                          getSelectedMapPlace($event)
                                        "></app-map-place>
                                      </div>
                                    </ng-template>

                                    <ng-container *ngIf="!event">
                                      <ng-template swiperSlide *ngFor="let sk of [].constructor(5)">
                                        <ngx-skeleton-loader [theme]="{
                                            width: '100%',
                                            height: '55px',
                                            margin: '0'
                                          }"></ngx-skeleton-loader>
                                      </ng-template>
                                    </ng-container>
                                  </swiper>
                                </div>

                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                  (click)="canShowMapPlace = false">
                                  Fechar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #showLoading>
                      <div class="d-flex justify-content-center">
                        <app-spinner spinnerType="grow" spinnerWidth="77"></app-spinner>
                      </div>
                    </ng-template>
                  </div>

                  <div *ngIf="event">
                    <div style="height: 69px" id="next"></div>
                    <div class="card-footer p-3" *ngIf="comissionerMode == false; else showSellButton">
                      <div class="d-flex flex-wrap align-items-center mb-3">
                        <input class="form-check-input m-0" type="checkbox" id="defaultCheck1"
                          [checked]="termsOfUseAccepted" (change)="termsOfUseChanged($event)" />
                        <label class="form-check-label ms-3" for="defaultCheck1">
                          TERMOS DE USO - Você precisa aceitar os seguintes
                          termos de uso para efetuar sua compra
                          <a target="_blank" [routerLink]="[
                              event.id == '8dc27a43-f22b-4137-a4cf-f1ec083ca6ea'
                                ? '/terms-of-use-porsche'
                                : '/terms-of-use'
                            ]">CLIQUE AQUI</a>
                        </label>
                      </div>

                      <!-- 8dc27a43-f22b-4137-a4cf-f1ec083ca6ea -->
                      <div class="d-flex">
                        <button class="btn btn-grad btn-lg fw-bold text-uppercase mx-auto d-flex"
                          [disabled]="loadingBuyedTickets == true" (click)="
                            event.id == '8dc27a43-f22b-4137-a4cf-f1ec083ca6ea'
                              ? openFormPorsche(formPorscheModal)
                              : buy()
                          ">
                          <span *ngIf="loadingSeatsIo == false; else showLoading">
                            <span class="d-flex align-items-center" *ngIf="amount() > 0; else showBuyButton">Avançar <i
                                class="fa fa-circle mx-2"></i> R$
                              {{ amount() | number : "1.2-2" }}</span>
                            <ng-template #showBuyButton>Avançar</ng-template>
                          </span>
                          <ng-template #showLoading>
                            <app-spinner spinnerType="grow" spinnerWidth="30"></app-spinner>
                          </ng-template>
                        </button>
                      </div>
                    </div>
                    <ng-template #showSellButton>
                      <div class="d-flex mb-3">
                        <button class="btn btn-grad btn-lg fw-bold text-uppercase mx-auto d-flex"
                          (click)="sell(titularModal)">
                          <span *ngIf="loadingSeatsIo == false; else showLoading">
                            <span class="d-flex align-items-center" *ngIf="amount() > 0; else showBuyButton">Vender <i
                                class="fa fa-circle mx-2"></i> R$
                              {{ amount() | number : "1.2-2" }}</span>
                            <ng-template #showBuyButton>Vender</ng-template>
                          </span>
                          <ng-template #showLoading>
                            <app-spinner spinnerType="grow" spinnerWidth="30"></app-spinner>
                          </ng-template>
                        </button>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #halfEntryModalInformation>
        <div class="modal-header">
          <h4 class="modal-title pull-left">Meia entrada</h4>
          <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="halfEntryModalInformationRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h2>POLÍTICA DE MEIA-ENTRADA</h2>

          <p>
            De acordo com o decreto nº 8.537 de 5 de outubro de 2015 que
            regulamenta a nova lei da meia-entrada (Lei n° 12.933/2013) e o
            Estatuto da Juventude (Lei n° 12.852/2013), a venda de meia-entrada
            está sujeita a disponibilidade da cota de 40% sobre o total de
            ingressos disponível para o evento.
          </p>
          <br />
          <br />
          <p>
            <b><u>Sobre o benefício da Meia-Entrada</u></b>
          </p>
          <ul>
            <li>
              O direito à Meia-Entrada é garantido por leis federais e
              regionais. As leis federais têm abrangência em todo território
              nacional e as leis regionais têm eficácia restrita ao território
              onde foram publicadas.
            </li>
            <li>
              As leis federais atualmente em vigor garantem o benefício da Meia
              entrada para idosos, estudantes, pessoas com deficiência e jovens
              de baixa renda, com idade entre 15 e 29 anos. As pessoas com
              direito ao benefício com base em leis regionais variam de acordo
              com o Estado ou Município que publicou a lei.
            </li>
            <li>
              É obrigatória a apresentação no estabelecimento, quando do acesso
              ao evento, da documentação que comprove o direito ao benefício de
              acordo com a legislação em vigor. A Ingresso SA não se
              responsabiliza pela não entrada no evento caso não ocorra a
              comprovação ou o não reconhecimento do benefício por parte do
              estabelecimento.
            </li>
          </ul>

          <h3>Estatuto do Idoso</h3>
          <ul>
            <li>
              De acordo com a Lei Federal no. 10741/2003, mais conhecida como
              Estatuto do Idoso, as pessoas com idade igual ou superior a 60
              anos tem direito à Meia-Entrada para eventos artísticos e de
              lazer.
            </li>
          </ul>

          <h3>Lei da meia entrada</h3>
          <ul>
            <li>
              A Lei Federal nº 12933/2013, também conhecida como Lei da
              Meia-Entrada, garante o benefício do pagamento de Meia-Entrada
              para estudantes, pessoas com deficiência e jovens, de baixa renda,
              com idade entre 15 e 29 anos.
            </li>
            <li>
              Somente farão jus ao benefício alunos da educação básica e
              educação superior, conforme previsto no Título V da Lei no 9.394,
              de 20.12.1996. A lei não estende o benefício a cursos livres, tais
              como cursos de inglês e informática.
            </li>
            <li>
              Pessoas com deficiência e quando necessário, seus acompanhantes,
              têm direito ao benefício.
            </li>
            <li>
              Jovens de 15 a 29 anos, cuja renda familiar mensal seja de até 02
              salários mínimos, desde que inscritos no Cadastro Único para
              Programas Sociais do Governo Federal, podem adquirir os ingressos
              com 50% de desconto.
            </li>
            <li>
              A concessão do direito ao benefício da Meia-Entrada é assegurada
              em 40% (quarenta por cento) do total dos ingressos disponíveis
              para cada evento.
            </li>
          </ul>

          <h3>Leis Regionais que garantem a Meia-Entrada</h3>
          <ul>
            <li>
              Alguns Estados e Municípios publicaram leis com eficácia regional
              como, por exemplo, a Lei Estadual (SP) 10.858/01, alterada pela
              Lei 14.729/12; Lei Municipal (Porto Alegre/RS) 7366/1993,
              regulamentada pelo Decreto 11.110, a Lei Municipal 9070/2005, de
              Belo Horizonte, a Lei Estadual (RJ) 3364/2000 e a Lei Municipal
              (Rio de Janeiro) 3424/2002.
            </li>
            <li>Verifique a legislação vigente no seu Estado ou Município.</li>
          </ul>

          <h3>SOBRE OS DOCUMENTOS VÁLIDOS</h3>
          <br />
          <p><b>ESTUDANTES</b></p>
          <p></p>

          <p>
            Carteira de Identificação Estudantil (CIE), emitida pela Associação
            Nacional de Pós-Graduandos (ANPG), União Nacional dos Estudantes
            (UNE), União Brasileira dos Estudantes Secundaristas (Ubes),
            entidades estudantis estaduais e municipais, Diretórios Centrais dos
            Estudantes, Centros e Diretórios Acadêmicos de nível médio e
            superior, conforme modelo único nacionalmente padronizado que você
            pode conferir neste link. (Art. 3º, §1º do Decreto 8.537/15)
            <br /><br />
            Os elementos indispensáveis da CIE são (Art. 3º, §2º e 2º, VI do
            Decreto 8.537/15):
          </p>

          <p>I - nome completo e data de nascimento do estudante;</p>
          <br />
          <p>II - foto recente do estudante;</p>
          <br />
          <p>
            III - nome da instituição de ensino na qual o estudante esteja
            matriculado;
          </p>
          <p>IV - grau de escolaridade; e</p>
          <br />
          <p>
            V - data de validade até o dia 31 de março do ano subsequente ao de
            sua expedição.
          </p>
          <br />
          <p>
            Lei Federal 12.933/13, Decreto Federal 8.537/15 e Medida Cautelar
            Provisória concedida pelo STF em 29/12/2015.
          </p>

          <br /><br />
          <p><b>IDOSOS (pessoas com mais de 60 anos)</b></p>
          <br />
          <p>Documento de identidade oficial com foto.</p>
          <br />
          <p>Lei Federal 10.741/03 (Art. 23).</p>
          <br /><br />

          <p>
            <b>PESSOAS COM DEFICIÊNCIA</b> (e acompanhante, quando necessário)
          </p>
          <br />
          <p>
            Cartão de Benefício de Prestação Continuada da Assistência Social da
            Pessoa com Deficiência ou de documento emitido pelo Instituto
            Nacional do Seguro Social - INSS que ateste a aposentadoria de
            acordo com os critérios estabelecidos na Lei Complementar nº 142, de
            8 de maio de 2013. No momento de utilização dos ingressos, esses
            documentos deverão estar acompanhados de documento de identidade
            oficial com foto. (Art. 6º do Decreto 8.537/15)
          </p>

          <br />
          <br />
          Lei Federal 12.933/13 e Decreto Federal 8.537/15

          <br />
          <br />
          <p>
            <b>MENORES DE 21 ANOS</b> (verifique a lei do seu estado/município
            antes de realizar sua compra)
          </p>
          <br />
          <p>Carteira de identidade ou documento com foto válido.</p>

          <br /><br />
          <p><b>PROFFISIONAIS DA EDUCAÇÃO</b></p>
          <br />
          <p>Lei Estadual RJ n° 3.364/00 e Lei Municipal BH n° 9.070/2005</p>
          <p>
            RJ - PROFESSORES E PROFISSIONAIS da rede pública municipal de ensino
            do Rio de Janeiro.
          </p>
          <p>
            Carteira funcional emitida pela Secretaria Municipal de Educação do
            Rio de Janeiro.
          </p>
          <p>
            Leis Municipais n° 3.424/02, com alterações introduzidas pela Lei
            Municipal nº 5.844/15.
          </p>
          <br /><br />
          <p>
            SP - PROFESSORES, DIRETORES, COORDENADORES PEDAGÓGICOS, SUPERVISORES
            E TITULARES de cargos do quadro de apoio das escolas das redes
            estadual e municipais de São Paulo
          </p>
          <br /><br />
          <p>
            Carteira funcional emitida pela Secretaria da Educação de São Paulo
            ou holerite acompanhado de documento oficial com foto.
          </p>
          <br /><br />
          <p>
            Lei Estadual n° 14.729/12, com alterações introduzidas pela Lei
            Estadual n°15.298/14.
          </p>

          <br />
          <br />
          <p>
            <b>DOADORES DE SANGUE</b> (registrados nos bancos de sangue dos
            hospitais estaduais)
          </p>
          <br />
          <p>
            Existem leis municipais e estaduais que regulamentam o benefício de
            meia-entrada para doadores de sangue. Consulte a legislação do
            município onde o cinema se localiza e, confirmado o direito de uso,
            você poderá comprar meia-entrada pelo nosso site, bastando inserir o
            número do RG no momento da compra e apresentar a carteira de doador
            de sangue na entrada da sala.
          </p>
          <br />
          <br />
          <p><b>JOVENS DE BAIXA RENDA</b></p>
          <br />
          <p>
            Carteira de Identidade Jovem emitida pela Secretaria Nacional de
            Juventude, acompanhada de documento de identidade oficial com foto.
            (Art. 5º do Decreto 8.537/15)
          </p>
          <br />
          <p>Lei Federal 12.933/13 e Decreto Federal 8.537/15</p>
          <br />
          <br />
        </div>
      </ng-template>

      <ng-template #formPorscheModal>
        <div class="modal-header">
          <h4 class="modal-title pull-left">
            Informações do Proprietário e do veículo
          </h4>
          <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="openFormPorscheModalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          Formulário de cadastro do proprietário (informações necessárias)

          <app-form-porsche-event [quantityTickets]="ownerPorscheTicketQuantity"
            (sendPorscheOwner)="getPorscheOwner($event)"></app-form-porsche-event>
        </div>
      </ng-template>

      <ng-template #titularModal>
        <div class="modal-header border-0 mx-2">
          <h4 class="modal-title pull-left" *ngIf="swiper?.activeIndex == 0">
            Titular dos ingressos
          </h4>
          <h4 class="modal-title pull-left" *ngIf="swiper?.activeIndex == 1">
            Forma de Pagamento
          </h4>
          <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="titularModalRef?.hide();this.selectedPaymentMethodName = ''">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <swiper [autoHeight]="false" [allowTouchMove]="false" (swiper)="onSwiper($event)">
            <ng-template swiperSlide>
              <div class="row p-2">
                <div class="col-sm-12">
                  <div>
                    <form [formGroup]="formHolder" (ngSubmit)="getHolder()">
                      <div class="row p-2">
                        <div class="col-sm-6">
                          <div class="form-floating mb-3">
                            <input type="text" required="true" (keyup)="checkCustomerRegister($event)"
                              mask="000.000.000-00" required class="form-control" formControlName="doc"
                              id="floatingInput" placeholder="000.000.000-00" />
                            <label for="floatingInput">CPF</label>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-floating mb-3">
                            <input type="email" required class="form-control" formControlName="email" id="floatingInput"
                              placeholder="name@example.com" />
                            <label for="floatingInput">Email</label>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-floating mb-3">
                            <input type="text" required class="form-control" formControlName="name" id="floatingInput"
                              placeholder="Nome" />
                            <label for="floatingInput">Nome completo</label>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-floating mb-3">
                            <input type="text" class="form-control" required mask="(00) 00000-0000 || (00) 0000-0000"
                              [dropSpecialCharacters]="false" formControlName="phone" id="floatingInput"
                              placeholder="(00) 00000-0000" />
                            <label for="floatingInput">Telefone</label>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-sm-12 text-center">
                  <button class="btn btn-grad btn-lg" (click)="getHolder()">
                    Continuar
                  </button>
                </div>
              </div>
            </ng-template>

            <ng-template swiperSlide>
              <div class="row p-2">
                <div class="col-md-12 mt-md-0 ms-auto mt-5">
                  <p class="mb-1">Detalhes da compra</p>

                  <div class="card">
                    <div class="table-responsive">
                      <table class="table">
                        <tbody>
                          <tr>
                            <th class="ps-3" scope="col">Ingresso</th>
                            <th class="text-center" scope="col">Qtd</th>
                            <th class="text-center pe-3" scope="col">Valor</th>
                          </tr>
                          <tr *ngFor="let ticket of allTickets">
                            <td class="align-middle ps-3">
                              <p class="text-grad fw-bold m-0">
                                {{ ticket.name }}
                              </p>
                              <p class="m-0" *ngIf="ticket.placeName">
                                Lugar: {{ ticket.placeName }}
                              </p>
                              <p class="m-0">{{ ticket.batch }}</p>
                            </td>
                            <td class="text-center align-middle">
                              {{ countTickets(ticket.id, ticket.placeName) }}
                            </td>
                            <td class="text-center align-middle pe-3">
                              R$ {{ amount(ticket) | number : "1.2-2" }}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-end border-0 pt-3" colspan="3">
                              <p class="text-grad fw-bold fs-3 m-0">
                                Total:&nbsp;R$ {{ amount() | number : "1.2-2" }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row p-2">
                <div class="col-sm-12">
                  <div>
                    <table class="table table-hover">
                      <tbody>
                        <ng-container *ngFor="let paymentMethod of event!.paymentMethods">
                          <tr *ngIf="paymentMethod!.name == 'Dinheiro'" role="button" (click)="
                              selectedPaymentMethod = paymentMethod.id;
                              selectedPaymentMethodName = paymentMethod.gateway;
                              openPaymentConfirmationModal(
                                paymentConfirmationModal
                              )
                            ">
                            <td class="align-middle border-0 py-3 fs-5">
                              Dinheiro
                            </td>
                            <td class="align-middle border-0 py-3 text-end">
                              <i class="las la-angle-right"></i>
                            </td>
                          </tr>
                        </ng-container>
                        <tr role="button" (click)="
                            selectedPaymentMethodName = '';
                            selectedPaymentMethod = ''; createSellOrder()
                          ">
                          <td class="align-middle border-0 py-3 fs-5">
                            Pix ou Cartão
                          </td>
                          <td class="align-middle border-0 py-3 text-end">
                            <i class="las la-angle-right"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-sm-12 text-center">
                  <button class="btn btn-grad btn-lg" (click)="swiper?.slideNext()" *ngIf="paymentMethod">
                    Continuar
                  </button>
                </div>
              </div>
            </ng-template>

            <ng-template swiperSlide>
              <div *ngIf="paymentCompleted == false; else showPaymentCompleted">
                <p class="mb-3 mt-3">
                  Copie e envie o link de pagamento para o cliente
                </p>
                <input type="text" id="selllink" class="form-control" [value]="
                    'Finalize o seu pagamento em '+site+'/event/' +
                    event!.id +
                    '?rfr=' +
                    orderId
                  " />
                <div class="mt-2 d-flex justify-content-center">
                  <button class="btn btn-grad btn-md mt-3" (click)="copySellLink()">
                    copiar link
                  </button>
                </div>
              </div>
              <ng-template #showPaymentCompleted>
                <p class="mb-3 mt-3">
                  Copie e envie o link do voucher para o cliente
                </p>
                <input type="text" id="selllink" class="form-control" [value]="
                    voucherlink+'voucher?id1=' + orderId
                  " />
                <div class="mt-2 d-flex justify-content-center">
                  <button class="btn btn-grad btn-md mt-3" (click)="copySellLink()">
                    copiar link
                  </button>
                </div>
              </ng-template>
            </ng-template>
          </swiper>
        </div>
      </ng-template>

      <ng-template #paymentConfirmationModal>
        <div class="modal-header border-0 mx-2">
          <h3>Confirmar que o pagamento foi realizado?</h3>
        </div>
        <div class="modal-body">
          <p>
            Ao clicar em sim, um voucher será gerado e o pagamento será
            concluído
          </p>
        </div>
        <div class="modal-footer border-0">
          <button class="btn btn-primary text-white" (click)="createSellOrder()" [disabled]="loading">
            <span *ngIf="!loading">SIM</span>
            <span *ngIf="loading">
              <app-spinner spinnerType="grow" spinnerWidth="20"></app-spinner>
            </span>
          </button>
          <button class="btn btn-danger"
            (click)="openPaymentConfirmationModalRef?.hide(); selectedPaymentMethodName = ''">
            NÃO
          </button>
        </div>
      </ng-template>
    </div>
  </div>
  <br>
</ng-template>